<template>
  <el-dialog title="Rate Matrix" :visible.sync="visible" :close-on-click-modal="false" width="1600px" top="2vh">
    <div class="mb10 contentHead">
      <span>Month:</span>
      <template v-if="dataRow.month">
        {{ dataRow.month.slice(0, 4) + "-" + dataRow.month.slice(4) }}
      </template>
    </div>
    <el-table tooltip-effect="dark" size="mini" fit :data="dataList" class="wdb100" height="80vh">
      <el-table-column label="Currency" header-align="center" align="left" width="130" fixed="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.currency }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Code" align="center" width="60" fixed="left">
        <template slot-scope="scope">
          <span>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="item in exRateCurrencyExclusiveList"
        :key="`rate-matrix-${item.currency}`"
        :label="item.currency"
        align="center"
        min-width="94"
      >
        <template slot-scope="scope">
          <span :class="{ bgGray: Number(scope.row[item.currency]) == 1 }">{{ scope.row[item.currency] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { isNumberLike } from "@/utils";
import { divide, fmoney } from "@/utils/count";
export default {
  props: {
    exRateCurrencyExclusiveList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataList: [],
      dataRow: {},
    };
  },
  methods: {
    // 初始化
    init(data) {
      this.dataList = [];
      const detailList = data.detailList || [];
      // SGD 为基准货币，接口不返回其汇率，手动插入一条 1:1 的记录
      if (!detailList.some(ele => ele.currency === "SGD")) {
        detailList.unshift({ currency: "SGD", exchangeRateBasis: "1", exchangeRateValue: "1" });
      }
      const exchangeRateObj = {};
      detailList.forEach(item => {
        exchangeRateObj[item.currency] = { exchangeRateBasis: item.exchangeRateBasis, exchangeRateValue: item.exchangeRateValue };
      });
      this.dataRow = {
        month: data.month,
        exchangeRateObj,
      };
      this.generateRateMatrix();
      this.visible = true;
    },
    // 生成汇率矩阵
    generateRateMatrix() {
      const matrix = [];
      // 遍历所有货币，生成矩阵行
      this.exRateCurrencyExclusiveList.forEach(fromCurrency => {
        const row = {
          currency: `${fromCurrency.currency} (${fromCurrency.title})`,
          code: fromCurrency.currency,
        };
        // 计算该行货币对其他所有货币的汇率
        this.exRateCurrencyExclusiveList.forEach(toCurrency => {
          const exchangeRateObj = this.dataRow.exchangeRateObj;
          const fromExRateBasis = exchangeRateObj[fromCurrency.currency]?.exchangeRateBasis;
          const fromExRateValue = exchangeRateObj[fromCurrency.currency]?.exchangeRateValue;
          const toExRateBasis = exchangeRateObj[toCurrency.currency]?.exchangeRateBasis;
          const toExRateValue = exchangeRateObj[toCurrency.currency]?.exchangeRateValue;
          // 计算汇率比例
          if (isNumberLike(fromExRateBasis) && isNumberLike(fromExRateValue) && isNumberLike(toExRateBasis) && isNumberLike(toExRateValue)) {
            // 获取基准货币的汇率值 = 保存的汇率 / 汇率基准金额
            const fromExRate = divide(fromExRateValue, fromExRateBasis);
            const toExRate = divide(toExRateValue, toExRateBasis);
            // 计算公式：目标货币汇率 / 源货币汇率
            const rate = divide(toExRate, fromExRate);
            // 根据不同货币的显示要求格式化数值
            const fromCurrency6DecimalPlaces = ["SGD", "EUR", "GBP", "USD", "SAR", "CHF", "THB", "AED"]; // 需要保留6位小数的币种
            if (fromCurrency6DecimalPlaces.includes(fromCurrency.currency) && toCurrency.currency == "VND") {
              row[toCurrency.currency] = fmoney(rate, 6);
            } else {
              row[toCurrency.currency] = fmoney(rate, 4);
            }
          } else {
            row[toCurrency.currency] = "N/A";
          }
        });
        matrix.push(row);
      });
      this.dataList = matrix;
    },
  },
};
</script>

<style lang="scss" scoped>
.contentHead {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 14px;
  background: #f5f7fa;
  font-size: 14px;
  color: #606266;

  span {
    color: #909399;
  }
}

.bgGray {
  display: inline-block;
  width: 100%;
  height: 100%;
  background: #ebeef5;
}
</style>
